/**
 * WebGLUnsupported.tsx
 * رسالة صريحة حين يعجز المتصفّح عن إنشاء سياق WebGL.
 *
 * بدونها كان الفشل صامتاً تماماً: MapLibre يرمي webglcontextcreationerror في الـ console،
 * فلا يُستدعى onLoad أبداً، فيبقى heatmapReady=false وتُكشف شاشة الافتتاح بالمهلة الزمنية
 * عن **سواد فارغ** بلا خريطة ولا سبب — يبدو للمستخدم كعطب في الموقع بينما السبب عنده
 * (تسريع عتادي مُطفأ أو تعريف رسوميات محجوب).
 */
import { useTranslation } from '../../i18n/LanguageContext';

/** يفحص دعم WebGL مباشرةً — نفس ما يفعله MapLibre داخلياً قبل بناء الخريطة. */
export function isWebGLAvailable(): boolean {
    try {
        const canvas = document.createElement('canvas');
        // ‏WebGL2 وحده: MapLibre 6 أزال دعم WebGL1، فجهازٌ بـ WebGL1 فقط كان سيجتاز هذا الفحص
        // ثم يرمي المُنشئ GPUInitializationError فتبقى الشاشة سوداء بلا تفسير. هنا يرى
        // الزائر رسالة «المتصفح لا يدعم» بدلها.
        return !!canvas.getContext('webgl2');
    } catch {
        return false;
    }
}

export function WebGLUnsupported() {
    const { t } = useTranslation();
    return (
        <div className="webgl-unsupported">
            <div className="webgl-unsupported-card">
                <h2>{t('webgl.title')}</h2>
                <p>{t('webgl.body')}</p>
                <ul>
                    <li>{t('webgl.fixEnable')}</li>
                    <li>{t('webgl.fixUpdate')}</li>
                    <li>{t('webgl.fixBrowser')}</li>
                </ul>
                <button type="button" onClick={() => window.location.reload()}>
                    {t('webgl.reload')}
                </button>
            </div>
        </div>
    );
}
